import {
  Avatar,
  Checkbox,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@linagora/twake-mui'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import React, { HTMLAttributes, SyntheticEvent } from 'react'
import { stringAvatar } from '@common/components/Event/utils/eventUtils'
import { ResourceIcon } from './ResourceIcon'
import { User, userIdentity } from './types'

export interface AttendeeOptionsListProps extends HTMLAttributes<HTMLLIElement> {
  options: User[]
  onOptionClick?: (user: User) => void
  selectedUsers: User[]
  keepSelectedOptions?: boolean
  onCheckboxToggle?: (event: SyntheticEvent, user: User) => void
}

export const AttendeeOptionsList: React.FC<AttendeeOptionsListProps> = ({
  options,
  onOptionClick,
  selectedUsers,
  keepSelectedOptions = false,
  onCheckboxToggle,
  ...props
}) => {
  return (
    <>
      {options.map(option => {
        const isSelected = selectedUsers.find(
          u => userIdentity(u) === userIdentity(option)
        )
        if (!keepSelectedOptions && isSelected) {
          return null
        }
        const isResource = option.objectType === 'resource'
        const isGroup = option.kind === 'group' || option.objectType === 'group'
        const memberCount = Number(
          option.eligibleMemberCount ?? option.memberCount ?? 0
        )
        return (
          <ListItem
            key={userIdentity(option)}
            onClick={() => onOptionClick?.(option)}
            disableGutters
            sx={{ cursor: 'pointer', py: 1 }}
            {...props}
          >
            <ListItemAvatar>
              {isResource ? (
                <ResourceIcon avatarUrl={option.avatarUrl} />
              ) : isGroup ? (
                <Avatar>
                  <GroupOutlinedIcon fontSize="small" />
                </Avatar>
              ) : (
                <Avatar {...stringAvatar(option.displayName || option.email)} />
              )}
            </ListItemAvatar>
            <ListItemText
              primary={option.displayName || option.email}
              secondary={
                isGroup
                  ? `${memberCount} ${memberCount === 1 ? 'участник' : 'участников'}`
                  : !isResource
                    ? option.email
                    : undefined
              }
              slotProps={{
                primary: { variant: 'body2' },
                secondary: { variant: 'caption' }
              }}
            />
            <Checkbox
              edge="end"
              size="small"
              checked={Boolean(isSelected)}
              disabled={option.selectable === false}
              tabIndex={-1}
              slotProps={{
                input: {
                  'aria-label': option.displayName || option.email,
                  onClick: (event: React.MouseEvent<HTMLInputElement>) => {
                    event.stopPropagation()
                    if (onCheckboxToggle) {
                      onCheckboxToggle(event, option)
                    } else {
                      onOptionClick?.(option)
                    }
                  }
                }
              }}
            />
          </ListItem>
        )
      })}
    </>
  )
}
